import { endpoints } from 'constants/endpoints';

import { sendRequest } from './sendRequest';

export const getChannelsApi = ({ thirdPartyType }) => {
  const url = endpoints.plugins.channel(thirdPartyType);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getTeamChannelMappingsApi = ({ thirdPartyType }) => {
  const url = endpoints.plugins.teamChannelMapping.index(thirdPartyType);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const saveTeamChannelMappingApi = ({ thirdPartyType, thirdPartyTeamId, thirdPartyTeamName, team }) => {
  const url = endpoints.plugins.teamChannelMapping.index(thirdPartyType);
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      thirdPartyTeamMappings: [
        {
          thirdPartyTeamId,
          thirdPartyTeamName,
          team,
        },
      ],
    },
  });
};

export const saveSlackApplauseMappingApi = ({ thirdPartyType, thirdPartyTeamId, thirdPartyTeamName }) => {
  const url = endpoints.plugins.teamChannelMapping.index(thirdPartyType);
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      thirdPartyTeamMappings: [
        {
          eventType: 'APPLAUSE',
          thirdPartyTeamId,
          thirdPartyTeamName,
        },
      ],
    },
  });
};

export const getSlackApplauseDetailsApi = () => {
  const url = endpoints.plugins.slack.applause;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      eventType: 'APPLAUSE',
    },
  });
};

export const updateTeamChannelMappingApi = ({
  thirdPartyType,
  mappingId,
  thirdPartyTeamId,
  thirdPartyTeamName,
  team,
}) => {
  const url = endpoints.plugins.teamChannelMapping.show(thirdPartyType, mappingId);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      thirdPartyTeamId,
      thirdPartyTeamName,
      team,
    },
  });
};

export const updateSlackApplauseChannelMappingApi = ({
  thirdPartyType,
  thirdPartyTeamId,
  thirdPartyTeamName,
  mappingId,
}) => {
  const url = endpoints.plugins.teamChannelMapping.show(thirdPartyType, mappingId);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      eventType: 'APPLAUSE',
      thirdPartyTeamId,
      thirdPartyTeamName,
    },
  });
};

export const deleteTeamChannelMappingApi = ({ thirdPartyType, mappingId }) => {
  const url = endpoints.plugins.teamChannelMapping.show(thirdPartyType, mappingId);
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
  });
};

export const getPluginFeaturesApi = ({ thirdPartyType }) => {
  const url = endpoints.plugins.features.index(thirdPartyType);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const updatePluginFeatureApi = ({ thirdPartyType, id, featureType, enabled }) => {
  const url = endpoints.plugins.features.show(thirdPartyType, id);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      featureType,
      enabled,
    },
  });
};

export const getAuthDetailsApi = ({ thirdPartyType }) => {
  const url = endpoints.plugins.authorizationDetails;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      type: thirdPartyType,
    },
  });
};

export const getDarwinBoxAuthDetailsApi = () => {
  const url = endpoints.plugins.darwinboxAuthDetails.authDetails;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const updateJiraAuthDetailsApi = ({ displayName, workspaceUrl, loginType }) => {
  const url = endpoints.plugins.authorizationDetails;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      displayName,
      workspaceUrl,
      loginType,
    },
  });
};
export const updateDarwinBoxAuthDetailsApi = ({ subdomain, apiKey, secretKey, uid, datasetKey }) => {
  const url = endpoints.plugins.darwinboxAuthDetails.authDetails;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      subdomain,
      apiKey,
      secretKey,
      uid,
      datasetKey,
    },
  });
};

export const getSlackAuthDetailsApi = () => {
  const url = endpoints.plugins.slack.authDetails;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

// HRIS plugin -- start
export const getLinkTokenApi = () => {
  const url = endpoints.plugins.mergeHRISIntegration.getLinkToken;

  return sendRequest({
    url,
    credentials: 'include',
  });
};

export const storePermanentAccountTokenApi = ({ public_token }) => {
  const url = endpoints.plugins.mergeHRISIntegration.storePermanentAccountToken;

  return sendRequest({
    url,
    method: 'POST',
    queryParams: { public_token },
    credentials: 'include',
  });
};

export const storePermanentAccountTokenFinchApi = ({ public_token }) => {
  const url = endpoints.plugins.finchHRISIntegration.storePermanentAccountToken;
  return sendRequest({
    url,
    method: 'POST',
    queryParams: { code: public_token },
    credentials: 'include',
  });
};

export const getMergeHRISAuthDetailsApi = () => {
  const url = endpoints.plugins.mergeHRISIntegration.authDetails;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getFinchHRISAuthDetailsApi = () => {
  const url = endpoints.plugins.finchHRISIntegration.authDetails;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const deactivateMergeHRISApi = () => {
  const url = endpoints.plugins.mergeHRISIntegration.deactivate;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

// HRIS plugin -- end

export const getCalendarAuthDetailsV2Api = () => {
  const url = endpoints.plugins.calendar.authDetailsv2;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getCalendarAuthURLsV2Api = ({ calendarType = '' }) => {
  const url = endpoints.plugins.calendar.authURL;
  const redirectUrl = `${window.location.origin}/calendar/verify/${calendarType?.toLowerCase()}`;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      calendarType,
      redirectUrl,
    },
  });
};

export const getCalendarAuthCodeV2Api = ({ calendarType, code, error, error_description }) => {
  const url = endpoints.plugins.calendar.authorizeCodev2(calendarType);
  const redirectUrl = `${window.location.origin}/calendar/verify/${calendarType?.toLowerCase()}`;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      code,
      error,
      error_description,
      redirectUrl,
    },
  });
};

export const deactivateCalendarPluginApiV2 = () => {
  const url = endpoints.plugins.calendar.deactivateV2;
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
  });
};
